﻿export class MortgageInquiryRequest {
    PDID: string;
}
